rEvent.on('Autocomplete.show', function() {
    if (checkResolution('cxs;xs')) {
        $('body').addClass('show-search');
    }

    $('.js-header-bottom').addClass('autocomplete-visible');
    addOverlay();
});

rEvent.on('Autocomplete.hide', function() {
    $('body').removeClass('show-search');

    removeOverlay();
    $('.js-header-bottom').removeClass('autocomplete-visible');
});

$(window).on('resize load', function() {
    if ($('.js-limit').length) {
        TABS.init();
        $('body').addClass('page-loaded');
    }
});

$(document).ready(function() {
    if ($('.js-limit').length) {
        TABS.init();
    }

    $('#main-menu > li:not(.header__nav__item--color) > a').on(
        'click',
        function() {
            var $li = $(this).parent('li');

            if ($li.find('.header__subnav').size() == 0) {
                return true;
            }

            if ($li.hasClass('open')) {
                // $('body').removeClass('show-subnav');
                $li.removeClass('open');
                removeOverlay();
            } else {
                // $('body').addClass('show-subnav');
                $('.header__nav__item.open').removeClass('open');
                $li.addClass('open');
                addOverlay();
            }

            bLazy.revalidate();

            setTimeout(function() {
                bLazy.revalidate();
            }, 250);

            return false;
        }
    );

    $('.header__links--search .header__link > a').on('click', function() {
        if ($(this).hasClass('open')) {
            $('body').removeClass('show-search');
            $(this).removeClass('open');
            removeOverlay();
        } else {
            if ($('body').hasClass('show-subnav')) {
                $('.aside__close').trigger('click');
            }
            $('body').addClass('show-search');
            $(this).addClass('open');
            $('.header__search input').focus();
            addOverlay();
        }
        return false;
    });

    $('.jsCloseSubnav').on('click', function() {
        $('body')
            .removeClass('show-search')
            .removeClass('show-subnav');
        $('header .header__nav__item').removeClass('open');
        removeOverlay();

        return false;
    });

    //minicart
    $('body').on('click', '.js-trigger-minicart', function(e) {
        const $headerMinicart = $('.js-header-minicart');

        if (checkResolution('cxs;xs')) {
            return true;
        }

        e.preventDefault();

        if ($headerMinicart.hasClass('is-active')) {
            removeOverlay();
            $headerMinicart.removeClass('is-active');
        } else {
            setTimeout(function() {
                addOverlay();
            }, 1);

            $('body').removeClass('show-subnav');
            $('#main-menu > li.open').removeClass('open');
            $headerMinicart.addClass('is-active');
        }
    });

    $('body').on('click', function(event) {
        const $headerMinicart = $('.js-header-minicart'),
            $minicartTrigger = $('.js-trigger-minicart');

        if (
            $('.sweet-alert').length &&
            !$('.sweet-alert').is(':visible') &&
            $headerMinicart.hasClass('is-active')
        ) {
            if (
                !$(event.target).closest($headerMinicart).length &&
                !$(event.target).closest($minicartTrigger).length
            ) {
                removeOverlay();
                $headerMinicart.removeClass('is-active');
            }
        }
    });

    $('body').on('click', '.js-autocomplete-search', function(e) {
        if (!$.trim($(this).attr('data-keyword'))) {
            e.preventDefault();
        }
    });

    // toggle password
    $('.js-toggle-password').on('click', function() {
        const $this = $(this),
            $input = $this.parent().find('.c-form__input'),
            type = $input.attr('type');

        if (type == 'text') {
            $input.attr('type', 'password');
        } else {
            $input.attr('type', 'text');
        }
    });
});

$(document).click(function(e) {
    if (
        !$(e.target).parents('#main-menu').length &&
        $('body').hasClass('show-subnav') &&
        $('.header__nav__item.open').length
    ) {
        removeOverlay();

        $('body').removeClass('show-subnav');
        $('.header__nav__item.open').removeClass('open');
    }
});

//navigation item responsive
var TABS = {
    wrapper: '.js-limit',
    init: function() {
        var n = this;
        n.reFlow(),
            $(window).on('resize', function() {
                n.reFlow();
            });
    },
    reFlow: function() {
        $(this.wrapper).each(function() {
            var n = $(this),
                i = n.outerWidth(),
                o = n
                    .find('.header__nav__item.header__nav__item--more > a')
                    .parent()
                    .outerWidth(),
                e = 0,
                d = n.find('>.header__nav__item:not(.header__nav__item--more)')
                    .length,
                t = !1;
            n.find('>.header__nav__item:not(.header__nav__item--more)').each(
                function(a, s) {
                    var r = $(this).outerWidth(!0);
                    n.find('.header__nav__item--more').is(':visible');
                    t || e + r + 1 > i || (e + r + o + 1 > i && a + 1 < d)
                        ? ($(this).hide(), (t = !0))
                        : $(this).css('display', 'inline-block'),
                        (e += r);
                }
            );
            var a = n.find(
                '>.header__nav__item:not(.header__nav__item--more):not(:visible)'
            );
            a.length > 0
                ? n
                      .find('.header__nav__item--more')
                      .css('display', 'inline-block')
                : n.find('.header__nav__item--more').hide(),
                n
                    .find('.dropdown-menu')
                    .html(a.clone().css('display', 'inline-block'))
                    .find('a')
                    .addClass('dropdown-item')
                    .removeClass('.header__nav__item')
                    .css('display', 'inline-block'),
                n.find('.dropdown-menu .dropdown-item').click(function() {
                    $(this)
                        .siblings()
                        .removeClass('active');
                });
        });
    },
};
